<div
  [ngClass]="windowState() === 'open' ? 'h-[300px]' : 'h-auto'"
  class="flex flex-col w-full justify-start align-center text-md font-bold px-4 p-y-2 max-h-[300px] pb-2"
>
  <div class="flex flex-row w-full justify-between items-center">
    @if (windowState() === 'open') {
      <div class="flex flex-row w-fit gap-4 p-2 rounded-xl bg-black cursor-pointer">
        <div
          [ngClass]="
            logType() === 'agentLog' ? 'bg-slate-700 text-white' : 'bg-transparent text-slate-400'
          "
          (click)="logType.set('agentLog')"
          class="flex flex-row gap-2 w-auto items-center text-xs p-2 bg-slate-700 rounded-lg"
          tabindex="0"
        >
          <i
            [value]="logs().length"
            class="ph ph-list-bullets text-xl"
            pBadge
            severity="secondary"
          ></i>
          Agent Log
        </div>
        <div
          [ngClass]="
            logType() === 'reasoning' ? 'bg-slate-700 text-white' : 'bg-transparent text-slate-400'
          "
          (click)="logType.set('reasoning')"
          class="flex flex-row gap-2 w-auto items-center text-xs p-2 rounded-lg cursor-pointer"
          tabindex="0"
        >
          <i
            [value]="reasoningLogs().length"
            class="ph ph-brain text-xl"
            pBadge
            severity="secondary"
            style="font-size: 2rem"
          ></i>
          Reasoning
        </div>
      </div>
      <div
        (click)="changeWindowState()"
        class="py-2 px-3 h-8 self-center font-semibold items-center flex text-center bg-neutral-700 rounded-lg text-xs gap-2 hover:bg-neutral-400 cursor-pointer"
        tabindex="0"
        pTooltip="Minimize / Maximize"
        tooltipPosition="bottom"
      >
        <i class="ph ph-caret-down text-sm"></i>
      </div>
    } @else {
      <div
        (click)="changeWindowState()"
        class="flex flex-row w-full rounded-lg gap-4 p-2 text-sm text-slate-400 font-semibold hover:bg-neutral-700 hover:text-white cursor-pointer items-center justify-between"
        tabindex="0"
        pTooltip="Show Agents Log & Reasoning"
        tooltipPosition="top"
      >
        <div class="flex flex-row gap-2 items-center">
          <i
            [value]="logs().length + reasoningLogs().length"
            class="ph ph-list-bullets text-xl"
            pBadge
            severity="secondary"
            style="font-size: 2rem"
          ></i>
          Agents Log & Reasoning
        </div>
        <div
          (click)="changeWindowState()"
          class="py-2 px-3 h-8 self-center font-semibold items-center flex text-center bg-neutral-700 rounded-lg text-xs gap-2 hover:bg-neutral-400 cursor-pointer"
          tabindex="0"
          pTooltip="Minimize / Maximize"
          tooltipPosition="bottom"
        >
          <i class="ph ph-caret-up text-sm"></i>
        </div>
      </div>
    }
  </div>
  @if (windowState() === 'open') {
    <div class="flex flex-col w-full h-full gap-1 mt-1 mb-2 p-1 rounded-md overflow-hidden">
      @if (logType() === 'reasoning') {
        <flx-ai-agent-reasoning
          class="flex h-full w-full scrollbar-dark overflow-hidden"
        ></flx-ai-agent-reasoning>
      } @else {
        <flx-ai-agent-log
          class="flex h-full w-full scrollbar-dark overflow-hidden"
        ></flx-ai-agent-log>
      }
    </div>
  }
</div>
